<template>
  <div class="caseResults">
    <!--<topfixed></topfixed>-->
    <div class="top_header">
      <p @click="actchange(0)">文旅规划设计</p>
      <p @click="actchange(1)">智慧文旅建设</p>
      <p @click="actchange(2)">文旅投资运营</p>
      <p @click="actchange(3)">目的地智慧营销</p>
      <div class="top_header_line">
        <span
          class="top_header_act"
          :style="{ marginLeft: actType * 25 + 5 + '%' }"
        ></span>
      </div>
    </div>
    <div class="photoLists clearfix">
      <ul>
        <li v-for="(item, index) in imgs" :key="index">
          <span class="bg"></span>
          <router-link :to="{ name: 'caseDetail', query: { id: item.articleId } }">
            <img :src="'http://citgroup.cn' + item.images" />
            <!--<img src="../../assets/images/anli1.png">-->
            <p class="textp">
              <span class="stitle" v-text="item.title"></span>
              <br />
              <span
                class="sdescrip"
                style="-webkit-box-orient: vertical"
                v-text="item.description"
              ></span>
            </p>
          </router-link>
        </li>
      </ul>
    </div>
    <!--加载更多按钮-->
    <div class="loadMore">
      <span class="moreSpan" v-if="caseshow" @click="morePhotos()">加载更多</span>
      <span v-else="caseshow">已加载全部</span>
    </div>
  </div>
</template>

<script>
import config from "../../assets/js/config.js";
//import topfixed from '../topfixed'

export default {
  name: "caseResults",
  data() {
    return {
      msg: "",
      imgs: [],
      casePage: 2,
      caseshow: true,
      actType: 0,
      columnId: 8840,
    };
  },
  mounted() {
    this.getPhotos();
  },
  methods: {
    getPhotos() {
      var that = this;
      that.$ajax
        .post(
          config.caseResults.caseList,
          JSON.stringify({ columnId: this.columnId, page: 1 })
        )
        .then(function (response) {
          console.log(response.data.data.article);
          that.imgs = response.data.data.article;
        });
    },
    actchange(type) {
      this.actType = type;
      if (this.actType == 0) this.columnId = 8840;
      if (this.actType == 1) this.columnId = 1100;
      if (this.actType == 2) this.columnId = 6946;
      if (this.actType == 3) this.columnId = 7470;

      this.imgs = [];
      this.casePage = 1;

      this.morePhotos();
    },
    morePhotos() {
      var that = this;
      that.$ajax
        .post(
          config.caseResults.caseList,
          JSON.stringify({ columnId: this.columnId, page: that.casePage })
        )
        .then(function (response) {
          console.log(response.data.data.article);
          let caseNum = Math.ceil(response.data.data.num / 10);
          if (response.data.data.article.length > 0) {
            if (that.casePage >= caseNum) {
              that.caseshow = false;
            }
            that.casePage++;
          }
          that.imgs = that.imgs.concat(response.data.data.article);
        });
    },
  },
  components: {
    //  topfixed:topfixed
  },
};
</script>

<style scoped>
.caseResults {
  margin-bottom: 1rem;
}
.topfixed-wrap {
  background: #010101 !important;
}
.photoLists {
  width: 98%;
  margin: 0 auto;
  margin-top: 0.45rem;
}
.top_header {
  width: 100%;
  display: flex;
  justify-content: center;
  height: 0.6rem;
  flex-wrap: wrap;
  margin-top: 0.5rem;
}
.top_header p {
  min-width: 25%;
  height: 0.5rem;
  max-width: 25%;
  font-size: 0.2rem;
  line-height: 0.5rem;
  color: #0b151a;
  cursor: pointer;
}
.top_header_line {
  min-width: 100%;
  max-width: 100%;
  height: 0.05rem;
}
.top_header_act {
  display: block;
  width: 15%;
  height: 0.03rem;
  background: #0b151a;
  margin-left: 5%;
  transition: margin-left 0.5s;
}
ul {
  width: 100%;
  display: inline-block;
}
li {
  width: 100%;
  position: relative;
  margin-bottom: 0.06rem;
}
img {
  width: 100%;
  height: 3.1rem;
  vertical-align: middle;
}
.bg {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  background: rgba(0, 0, 0, 0.3);
}
.textp {
  position: absolute;
  width: 80%;
  margin: 0 10%;
  text-align: center;
  z-index: 3;
  top: 30%;
  color: #fff;
}
.stitle {
  font-size: 0.26rem;
}
.sdescrip {
  font-size: 0.2rem;
  color: #fefefecc;
  text-align: left;
  text-indent: 2em;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
  -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
  -webkit-line-clamp: 3; /** 显示的行数 **/
  overflow: hidden; /** 隐藏超出的内容 **/
  margin-top: 0.1rem;
}
.loadMore {
  padding: 0.2rem 0 1.6rem;
  font-size: 0.24rem;
}
.moreSpan {
  display: block;
  width: 100%;
  height: 0.5rem;
  line-height: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/caseResults/caseResults.vue